import 'twin.macro';
import React, { ReactNode, ReactElement } from 'react';
import _isEmpty from 'lodash-es/isEmpty';
import { AIGeneratedDisplay } from './AIGeneratedDisplay';
import { useAIErrorHandler } from './hooks/useAIErrorHandler';
import { AIWrapperContext } from './AIWrapperContext';
import { AIActions } from './components/AIActions';

export interface AIHookResult {
  data: string;
  error: string | null;
  isLoading: boolean;
  startGeneration: (params: any) => void;
  reset: () => void;
  stop: () => void;
}

interface Props {
  value: string;
  onChange?: (value: string) => void;
  aiHook: AIHookResult;
  showTypingEffect?: boolean;
  additionalActions?: ReactElement;
  children: ReactNode;
}

function AIWrapperBase({
  value,
  onChange,
  aiHook,
  showTypingEffect = false,
  additionalActions,
  children,
}: Props) {
  const { data, error, reset } = aiHook;

  useAIErrorHandler(error);

  const handleApply = () => {
    onChange?.(data);
    reset();
  };

  const contextValue = {
    aiHook,
    value,
    onChange,
    showTypingEffect,
  };

  return (
    <AIWrapperContext.Provider value={contextValue}>
      <>
        <div tw="relative">{children}</div>

        {!_isEmpty(data) && (
          <AIGeneratedDisplay
            data={data}
            onApply={handleApply}
            onIgnore={reset}
            showTypingEffect={showTypingEffect}
            additionalActions={additionalActions}
          />
        )}
      </>
    </AIWrapperContext.Provider>
  );
}

// Export compound component
export const AIWrapper = Object.assign(AIWrapperBase, {
  Actions: AIActions,
});
